// components/FilePreviewCard.js
import React from "react";
import styled from "styled-components";
import {
  DeleteIcon,
  PdfIcon,
  PlayIcon,
  ResendIcon,
} from "../../../styled/AllImages";
import { Box, LazyImage, SpanStyled } from "../../../styled/Elements";
import { useTranslation } from "react-i18next";

const Card = styled.div`
  position: relative;
  width: 110px;
  height: 110px;
  border-radius: 12px;
  background-color: var(--bgPrimary);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  margin-right: 10px;

  .buttons-wrapper {
    margin-right: ${({ lang }) => (lang === "en" ? "15px" : "unset")};
    margin-left: ${({ lang }) => (lang === "ar" ? "15px" : "unset")};
  }

  .content-wrapper {
    background-color: var(--white);
    width: 100%;
    height: 70%;
    margin-right: 15px;
    margin-left: 17px;
    border-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }
`;

const Thumbnail = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  &.pdf {
    object-fit: contain;
  }
`;

const VideoOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* background: rgba(0, 0, 0, 0.4); */
  display: flex;
  align-items: center;
  justify-content: center;
`;

const RemoveBtn = styled.button`
  background: white;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
`;

const FilePreviewCard = ({ file, onRemove }) => {
  const ASSET_URL = process.env.REACT_APP_ASSET_URL;
  const {
    t,
    i18n: { language },
  } = useTranslation();

  // Determine preview URL
  const isFileObject = file instanceof File;
  const url = isFileObject ? URL.createObjectURL(file) : `${ASSET_URL}/${file}`;

  // Get name for display
  const name = isFileObject ? file.name : url?.split("/").pop().split("?")[0];

  // Determine file type based on object or extension
  const getType = () => {
    if (isFileObject && file.type) return file.type;

    const ext = name.split(".").pop().toLowerCase();
    if (["jpg", "jpeg", "png", "webp", "gif", "bmp", "svg"].includes(ext))
      return "image";
    if (["mp4", "webm", "ogg", "mov", "mkv"].includes(ext)) return "video";
    if (ext === "pdf") return "pdf";
    return "other";
  };

  const fileType = getType();
  console.log(fileType);
  

  const getPreviewContent = () => {
    if (fileType?.includes("image")) {
      return (
        <Box className="d-flex align-items-center gap-3 py-2">
          <Box
            style={{
              width: "50px",
              height: "50px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Thumbnail src={url} alt={name} />
          </Box>
          <Box className="d-flex flex-column">
            <SpanStyled color="var(--text)" weight="bold" size="14px">
              {name}
            </SpanStyled>
            <SpanStyled color="var(--text2)" size="14px">
              {t("max_file_size")}: 2 MB
            </SpanStyled>
          </Box>
        </Box>
      );
    }

    if (fileType?.includes("video")) {
      return (
        <>
          <Thumbnail as="video" src={url} muted />
          <VideoOverlay>
            <LazyImage src={PlayIcon}/>
          </VideoOverlay>
        </>
      );
    }

    if (fileType === "pdf" || fileType === "application/pdf") {
      return (
        <Box className="d-flex align-items-center gap-3 h-100 py-2">
          <Thumbnail src={PdfIcon} alt="PDF" className="pdf" />
          <Box className="d-flex flex-column">
            <SpanStyled color="var(--text)" weight="bold" size="14px">
              {name}
            </SpanStyled>
            <SpanStyled color="var(--text2)" size="14px">
              {t("max_file_size")}: 2 MB
            </SpanStyled>
          </Box>
        </Box>
      );
    }

    return (
      <SpanStyled color="var(--text)" size="14px">
        {name}
      </SpanStyled>
    );
  };

  return (
    <Card lang={language}>
      <Box className="content-wrapper">{getPreviewContent()}</Box>
      <Box className="d-flex gap-2 flex-column buttons-wrapper">
        <RemoveBtn type="button" onClick={onRemove}>
          <DeleteIcon size={14} />
        </RemoveBtn>
        <RemoveBtn type="button" onClick={onRemove}>
          <ResendIcon size={14} />
        </RemoveBtn>
      </Box>
    </Card>
  );
};

export default FilePreviewCard;

// // components/FilePreviewCard.js
// import React from "react";
// import styled from "styled-components";
// import {
//   DeleteIcon,
//   PdfIcon,
//   ResendIcon,
//   Trash,
// } from "../../../styled/AllImages";
// import { Box, SpanStyled } from "../../../styled/Elements";
// import { useTranslation } from "react-i18next";

// const Card = styled.div`
//   position: relative;
//   width: 110px;
//   height: 110px;
//   border-radius: 12px;
//   background-color: var(--bgPrimary);
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   overflow: hidden;
//   margin-right: 10px;
//   .buttons-wrapper {
//     margin-right: ${({ lang }) => (lang === "en" ? "15px" : "unset")};
//     margin-left: ${({ lang }) => (lang === "ar" ? "15px" : "unset")};
//   }
//   .content-wrapper {
//     background-color: var(--white);
//     width: 100%;
//     height: 70%;
//     margin-right: 15px;
//     margin-left: 17px;
//     border-radius: 15px;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     position: relative;
//   }
// `;

// const Thumbnail = styled.img`
//   width: 100%;
//   height: 100%;
//   object-fit: cover;
// `;

// const VideoOverlay = styled.div`
//   position: absolute;
//   top: 0;
//   left: 0;
//   right: 0;
//   bottom: 0;
//   background: rgba(0, 0, 0, 0.4);
//   display: flex;
//   align-items: center;
//   justify-content: center;
// `;

// const RemoveBtn = styled.button`
//   /* position: absolute;
//   top: 4px;
//   right: 4px; */
//   background: white;
//   border-radius: 10px;
//   border: none;
//   cursor: pointer;
//   padding: 4px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   z-index: 2;
// `;

// const FilePreviewCard = ({ file, onRemove }) => {
//   const {
//     t,
//     i18n: { language },
//   } = useTranslation();
//   const getPreviewContent = () => {
//     let url;
//     if(file instanceof File) {
//       url = URL.createObjectURL(file);
//     }else {
//       url = file
//     }

//     if (file?.type?.startsWith("image/")) {
//       return (
//         <Box className="d-flex align-items-center gap-3">
//           <Box
//             style={{
//               width: "50px",
//               height: "50px",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//           >
//             <Thumbnail src={url} alt={file.name} />
//           </Box>
//           <Box className="d-flex flex-column">
//             <SpanStyled color="var(--text)" weight="bold" size="14px">
//               {file.name}
//             </SpanStyled>
//             <SpanStyled color="var(--text2)" size="14px">
//               {t("max_file_size")}: 2 MB
//             </SpanStyled>
//           </Box>
//         </Box>
//       );
//     }

//     if (file.type.startsWith("video/")) {
//       return (
//         <>
//           <Thumbnail as="video" src={url} />
//           <VideoOverlay>
//             <span style={{ color: "white", fontSize: 24 }}>▶</span>
//           </VideoOverlay>
//         </>
//       );
//     }

//     if (file.type === "application/pdf") {
//       return (
//         <Box className="d-flex align-items-center gap-3">
//           <Thumbnail src={PdfIcon} alt="PDF" />
//           <Box className="d-flex flex-column">
//             <SpanStyled color="var(--text)" weight="bold" size="14px">
//               {file.name}
//             </SpanStyled>
//             <SpanStyled color="var(--text2)" size="14px">
//               {t("max_file_size")}: 2 MB
//             </SpanStyled>
//           </Box>
//         </Box>
//       );
//     }

//     return <span>{file.name}</span>;
//   };

//   return (
//     <Card lang={language}>
//       <Box className="content-wrapper">{getPreviewContent()}</Box>
//       <Box className="d-flex gap-2 flex-column buttons-wrapper">
//         <RemoveBtn type="button" onClick={onRemove}>
//           <DeleteIcon size={14} />
//         </RemoveBtn>
//         <RemoveBtn type="button" onClick={onRemove}>
//           <ResendIcon size={14} />
//         </RemoveBtn>
//       </Box>
//     </Card>
//   );
// };

// export default FilePreviewCard;
